import React from 'react';
import * as d3 from 'd3';
import ExpandableAutoComplete from 'src/components/UI/button/ExpandableAutoComplete';
import { Box } from '@mui/material';

// The standard open scale (viewportMath STANDARD_OPEN_SCALE): a locate zooms TO it,
// as it always did, rather than keeping whatever zoom the chart is at.
const LOCATE_SCALE = 0.3;

function LocatePerson({ pedref, members, handleClick, onCenter }) {
  const locate = (upn) => {
    const groups = d3
      .select(pedref.current)
      .selectAll('g')
      .filter(function (d) {
        if (upn === 1) return d?.proBandId;

        if (d && d.upn && Number(d.upn) === upn) {
          return d;
        }
      });

    if (groups?._groups[0]?.length > 0) {
      const target = groups.select('path.te');
      const nodeData = target.datum();

      // TGCLOUD-1863: pan through the canvas's OWN zoom behaviour. The private
      // zoom behaviour this used to run never wrote the chart's per-family restore
      // point (zoom.js), so the very next re-render — an edit, a legend map —
      // snapped the view back to wherever it was before the locate. It also
      // hard-coded a 1140×860 viewport. `onCenter` is Canvas's centerOn through
      // ChartBox, which centres in the uncovered canvas and persists the view.
      if (onCenter && nodeData?.pid != null) {
        onCenter(nodeData.pid, { scale: LOCATE_SCALE });
      }

      handleClick(null, nodeData, target.node(), null);
    }
  };

  const onChange = (e, option) => {
    e.preventDefault();
    e.stopPropagation();
    if (option?.upn) locate(option.upn);
  };

  const locateMenu = React.useMemo(() => {
    const options = members
      ? members
          .map((member) => {
            if (member.upn)
              return {
                upn: Number(member.upn),
                label: `UPN ${member.upn}  ${
                  member.firstName
                    ? '- ' + member.firstName + ' ' + (member.lastName || '')
                    : ''
                }`
              };
            else if (member.proBandId)
              return {
                upn: 1,
                label: `UPN 1  ${
                  member.firstName
                    ? '- ' + member.firstName + ' ' + (member.lastName || '')
                    : ''
                }`
              };
          })
          .filter((m) => m)
          .sort((a, b) => a.upn - b.upn)
      : [];

    return (
      <>
        <ExpandableAutoComplete options={options} onChange={onChange} />
      </>
    );
  }, [members]);

  return <Box>{locateMenu}</Box>;
}

export default LocatePerson;
